'use client';

import './payment-settings.scss';

import { useTranslation } from 'react-i18next';

import { usePaymentMethodsWithCommitments } from '@sola/supporter-sdk/hooks/payment-methods.js';

import { LocalAlertsProvider } from '../../molecules/local-alerts/local-alerts-provider.js';
import { LocalAlerts } from '../../molecules/local-alerts/local-alerts.js';
import { PaymentMethodCard } from '../../molecules/payment-method-card/payment-method-card.js';
import { SectionContent } from '../../molecules/section-content/section-content.js';
import { PaymentIssueAlert } from '../payment-issue-alert/payment-issue-alert.js';
import { PaymentMethodAddSheet } from '../payment-method-add-sheet/payment-method-add-sheet.js';
import {
  AddPaymentMethodButton,
  AddPaymentMethodButtonLabel,
} from './payment-settings-add.js';

const useComponentData = () => {
  return usePaymentMethodsWithCommitments();
};

export const PaymentSettings = () => {
  const { t } = useTranslation('my');
  const {
    isLoading,
    paymentMethods,
    commitmentsByPaymentMethodId,
    commitments,
  } = usePaymentMethodsWithCommitments();

  return (
    <div className="PaymentSettings max-w-md flex flex-col gap-comfy-xl">
      {!isLoading && <PaymentIssueAlert isSimple onlyShowMissingPayment />}

      <LocalAlertsProvider>
        <LocalAlerts className="flex flex-col gap-comfy-sm" />

        <SectionContent
          heading={t('payments.methods.heading')}
          isLoadingContent={isLoading}
        >
          {!isLoading && (
            <>
              {!!paymentMethods.length &&
                paymentMethods
                  // Probably unecessary.
                  .filter((method) => !!method.id)
                  .map((method) => {
                    return (
                      <PaymentMethodCard
                        key={`payment-method-card-${method.id}`}
                        paymentMethod={method}
                        paymentMethodCommitments={
                          commitmentsByPaymentMethodId?.[method.id!] ?? []
                        }
                        allCommitments={commitments}
                      />
                    );
                  })}
              <PaymentMethodAddSheet
                commitments={commitments}
                openTrigger={
                  <AddPaymentMethodButton>
                    <AddPaymentMethodButtonLabel>
                      {t('payments.addPaymentMethod')}
                    </AddPaymentMethodButtonLabel>
                  </AddPaymentMethodButton>
                }
              />
            </>
          )}
        </SectionContent>
      </LocalAlertsProvider>
    </div>
  );
};
